import React from 'react';

import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    textAlign: 'center'
  },
  title: { fontSize: '24px' },
  content: {
    textAlign: 'center',
    padding: theme.spacing(3)
  }
}));

interface ErrorModal {
  error: boolean,
  setError: (val: boolean) => void
}

const ErrorModal = ({ error, setError }: ErrorModal) => {
  const classes = useStyles();
  return (
    <Dialog open={error} onClose={() => setError(false)}>
      <DialogTitle className={classes.dialogTitle}>
        <Translate content='error_oops' className={classes.title} />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Translate content='error_unexpected' />
      </DialogContent>
    </Dialog>
  );
};

export default ErrorModal;
